var loaderTheme = {
  loader: {
    height: 4,
    width: {
      default: 1.25,
      isFullScreen: 3.25
    }
  }
};
export default loaderTheme;